// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2sA_F","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__22V_e"};